<div [ngClass]="getKpiStatusStyleClass()" class="no-pallets">
  <div>
    <div class="no-pallets__label">{{ title }}</div>
    <div class="no-pallets__valuecontainer">
      <span class="no-pallets__valuecontainer--value">{{ value }}</span>
      <span class="no-pallets__valuecontainer--unit" [ngClass]="getKpiUnitTextColor()">&nbsp; {{ unit | formatUnitId }}</span>
    </div>
  </div>
  <div>
    <i class="no-pallets__icon" [ngClass]="getKpiStatusStyleIconClass()"></i>
  </div>
</div>
